import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reconciliationApi } from '../services/api-client';
import { reconciliationKeys } from './useReconciliationAlerts';
import type { ReconciliationFindingRow, ResolveFindingPayload } from '../types';

export function useResolveFinding() {
  const queryClient = useQueryClient();

  return useMutation<
    ReconciliationFindingRow,
    Error,
    { findingId: string; payload: ResolveFindingPayload }
  >({
    mutationFn: ({ findingId, payload }) =>
      reconciliationApi.resolveFinding(findingId, payload),
    onSuccess: (_data, variables) => {
      // Invalidate both findings list and alerts summary
      queryClient.invalidateQueries({ queryKey: reconciliationKeys.all });
      queryClient.invalidateQueries({ queryKey: reconciliationKeys.findingDetail(variables.findingId) });
    },
  });
}
